import React from "react";
import {
  DownOutlined,
  UserOutlined,
  PlusCircleOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Dropdown, Button, Avatar, Modal, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const DropDownMyAccountMenu = ({ profile }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [loggingOut, setLoggingOut] = React.useState(false);

  const username = profile?.username?.trim();
  const canViewProfile = Boolean(username);

  const goToProfile = React.useCallback(() => {
    if (canViewProfile) {
      navigate(`/profile/${username}`);
    } else {
      navigate("/404");
    }
  }, [canViewProfile, username, navigate]);

  const goToAddRecipe = React.useCallback(() => {
    navigate("/new_post");
  }, [navigate]);

  const confirmLogout = React.useCallback(() => {
    Modal.confirm({
      title: "Log out?",
      content: "You can sign back in anytime.",
      okText: "Log out",
      cancelText: "Cancel",
      centered: true,
      okButtonProps: { danger: true, loading: loggingOut },
      onOk: async () => {
        try {
          setLoggingOut(true);
          await logout();
          message.success("Signed out");
        } catch (e) {
          message.error("Sign out failed. Please try again.");
        } finally {
          setLoggingOut(false);
        }
      },
    });
  }, [logout, loggingOut]);

  const items = [
    {
      key: "profile",
      label: "Profile",
      icon: <UserOutlined />,
      disabled: !canViewProfile,
    },
    { type: "divider" },
    {
      key: "add",
      label: "Add a Recipe",
      icon: <PlusCircleOutlined />,
    },
    { type: "divider" },
    {
      key: "logout",
      label: "Log out",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  const onMenuClick = ({ key }) => {
    switch (key) {
      case "profile":
        return goToProfile();
      case "add":
        return goToAddRecipe();
      case "logout":
        return confirmLogout();
      default:
        return;
    }
  };

  return (
    <Dropdown
      trigger={["click"]}
      menu={{ items, onClick: onMenuClick }}
      placement="bottomRight"
    >
      <Button
        type="text"
        className="flex items-center gap-2"
        aria-label="Open account menu"
      >
        <Avatar size="small" icon={<UserOutlined />} className="bg-rose-500" />
        <span className="hidden sm:inline font-medium">
          {canViewProfile ? username : "My Account"}
        </span>
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default DropDownMyAccountMenu;
